import request from './service/index';
// scholarlist
export function scholarSearch_Api(data){//查询列表
    return request({
        url:'CMS/scholar/scholar_list',
        method:'post',
        data:data
    });
}
export function deleteScholar_Api(data){//批量删除
    return request({
        url:'CMS/scholar/scholar_list',
        method:'delete',
        data:data
    })
}

// scholar 数量
export function getScholarCount_Api(){
    return request({
        url:'CMS/scholar/scholar_count',
        method:'get'
    })
}

// scholar 院校
export function updateCollege_Api(data){//更新
    return request({
        url:'CMS/scholar/scholar_college',
        method:'put',
        data:data
    })
}
export function addCollege_Api(data){//增加
    return request({
        url:'CMS/scholar/scholar_college',
        method:'post',
        data:data
    })
}
export function getCollege_Api(){//查询
    return request({
        url:`CMS/scholar/scholar_college`,
        method:'get'
    })
}
export function deleteCollege_Api(data){//删除
    return request({
        url:`CMS/scholar/scholar_college`,
        method:'delete',
        data:data
    })
}


// scholar 细节
export function searchScholar_Api(id){
    return request({
        url:`CMS/scholar/scholar_detail?scholar_id=${id}`,
        method:'get',
    })
}
export function deleteScholarTopics_Api(data){
    return request({
        url:`/CMS/scholar/scholar_detail`,
        method:'delete',
        data:data
    });
}
export function addScholar_Api(data){
    return request({
        url:`/CMS/scholar/scholar_detail`,
        method:'post',
        data:data
    })
}
export function updateScholar_Api(data){
    return request({
        url:`/CMS/scholar/scholar_detail`,
        method:'put',
        data:data
    })
}

//scholar 职称
export function searchScholarTitle_Api(){
    return request({
        url:`CMS/scholar/scholar_title`,
        method:'get',
    })
}
export function deleteScholarTitle_Api(data){
    return request({
        url:`/CMS/scholar/scholar_title`,
        method:'delete',
        data:data
    });
}
export function addScholarTitle_Api(data){
    return request({
        url:`/CMS/scholar/scholar_title`,
        method:'post',
        data:data
    })
}
export function updateScholarTitle_Api(data){
    return request({
        url:`/CMS/scholar/scholar_title`,
        method:'put',
        data:data
    })
}


export function ScholarCollegeTopics_Api(){
    return request({
        url:`CMS/tools/scholar_college_drop_down`,
        method:'get',
    })
}
export function ScholarCountryTopics_Api(){
    return request({
        url:`CMS/tools/country_drop_down`,
        method:'get',
    })
}
export function ScholarTitleTopics_Api(){
    return request({
        url:`CMS/tools/scholar_title_drop_down`,
        method:'get',
    })
}
export function ScholarUniversityTopics_Api(){
    return request({
        url:`CMS/tools/university_drop_down`,
        method:'get',
    })
}

export function scholarUniversityDropDown_Api(keyword){
    return request({
        url:`/CMS/tools/university_search_box?keyword=${keyword}`,
        method:'get',
    })
}

export function outputScholar_Api(data){
    return request({
        url:'CMS/scholar/output',
        method:'post',
        data:data,
        responseType: 'arraybuffer',
    })
}


export function scholarSubjectDropDown_Api(){
    return request({
        url:'CMS/tools/scholar_subject_drop_down',
        method:'get',
    })
}

export function updateScholarSubject_Api(data){//更新
    return request({
        url:'CMS/scholar/scholar_subject',
        method:'put',
        data:data
    })
}
export function addScholarSubject_Api(data){//增加
    return request({
        url:'CMS/scholar/scholar_subject',
        method:'post',
        data:data
    })
}
export function getScholarSubject_Api(){//查询
    return request({
        url:`CMS/scholar/scholar_subject`,
        method:'get'
    })
}
export function deleteScholarSubject_Api(data){//删除
    return request({
        url:`CMS/scholar/scholar_subject`,
        method:'delete',
        data:data
    })
}



// WEBPACK FOOTER //
// ./src/apis/scholar.api.js